export default __webpack_public_path__ + "static/media/campana.7a7519c1.png";